<template>
  <game-template title="Répondez aux 7 questions suivantes">
    <template v-slot:content>
      <div class="quizz-wrapper">
        <quizz
          :show-index="false"
          :question="currentQuestion"
          :question-name="currentQuestionLabel"
          :nb-question="questions.length"
          :index="questionIndex"
          @answered="setQuestionStatus"
          @next-question="nextQuestion">
        </quizz>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import quizzMixin from '@shared/mixins/quizzMixin'
import Quizz from '@shared/components/Quizz'

export default {
  name: 'PrimeQuizz',
  mixins: [stepMixin, quizzMixin],
  components: {
    Quizz
  },
  data () {
    return {
      questionIndex: 0,
      questions: [
        {
          name: 'q1',
          question: 'La loi définit le travail de nuit, le travail effectué entre',
          answers: [
            {
              name: 'a',
              label: '21h et 6h',
              isValid: true
            },
            {
              name: 'b',
              label: '22h et 6h',
              isValid: false
            },
            {
              name: 'c',
              label: '00h et 6h',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q2',
          question: 'Le travail exceptionnel de nuit donne droit à ',
          answers: [
            {
              name: 'a',
              label: 'Une majoration de  75%',
              isValid: true
            },
            {
              name: 'b',
              label: 'Un repas',
              isValid: false
            },
            {
              name: 'c',
              label: 'Rien',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q3',
          question: 'Le travail de nuit est interdit pour',
          answers: [
            {
              name: 'a',
              label: 'Les collaborateurs en CDD',
              isValid: false
            },
            {
              name: 'b',
              label: 'Les collaborateurs de moins de 20 ans',
              isValid: false
            },
            {
              name: 'c',
              label: 'Les mères d\'enfants de moins de 3 ans',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q4',
          question: 'La prime d\'amplitude est accordée en cas de travail',
          answers: [
            {
              name: 'a',
              label: 'Le samedi après 19h',
              isValid: false
            },
            {
              name: 'b',
              label: 'Plus de 10h sur une journée',
              isValid: false
            },
            {
              name: 'c',
              label: 'Le samedi après 12h30',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q5',
          question: 'La prime de soirée est accordée',
          answers: [
            {
              name: 'a',
              label: 'Aux salariés à temps partiel après 18h30',
              isValid: false
            },
            {
              name: 'b',
              label: 'A tous les salariés (hors forfait jours) qui travaillent au-delà de 18h30 en semaine (du lundi au vendredi)',
              isValid: true
            },
            {
              name: 'c',
              label: 'En cas de fermeture 3 jours par semaine',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q6',
          question: 'Si le jour férié tombe sur un repos hebdomadaire habituel, le collaborateur...',
          answers: [
            {
              name: 'a',
              label: 'Peut se faire indemniser ',
              isValid: false
            },
            {
              name: 'b',
              label: 'A le droit de prendre un autre jour de repos dans la semaine',
              isValid: false
            },
            {
              name: 'c',
              label: 'N\'a le droit à aucune compensation',
              isValid: true
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q7',
          question: 'Quand le jour férié est travaillé',
          answers: [
            {
              name: 'a',
              label: 'Une majoration de 100% des heures travaillées est versée',
              isValid: true
            },
            {
              name: 'b',
              label: 'Les heures sont obligatoirement mises en récupération',
              isValid: false
            },
            {
              name: 'c',
              label: 'Le jour d\'après, le collaborateur ne doit pas travailler ',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q8',
          question: 'Mon reflexe en cas de doute',
          answers: [
            {
              name: 'a',
              label: 'Ne rien faire',
              isValid: false
            },
            {
              name: 'b',
              label: 'Consulter la Direction RH et la documentation à ma disposition sur le sujet',
              isValid: true
            },
            {
              name: 'c',
              label: 'Je m\'arrange avec le collaborateur',
              isValid: false
            }
          ],
          status: 'remaining'
        },
        {
          name: 'q9',
          question: 'Mon salarié travaille un jour férié ou un dimanche',
          answers: [
            {
              name: 'a',
              label: 'Les heures sont systématiquement décomptées en heures supplémentaires',
              isValid: false
            },
            {
              name: 'b',
              label: 'Il y a des heures éxcédentaires uniquement si le temps de travail de la semaine ou du cycle en prévoit',
              isValid: true
            },
            {
              name: 'c',
              label: 'Il n\'y a aucun impact',
              isValid: false
            }
          ],
          status: 'remaining'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.quizz-wrapper {
  padding: 10px 128px 20px 128px;
}
</style>
